import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CategoryListLayer from "../components/CategoryListLayer";

const CategoryListPage = () => {
    return (
        <MasterLayout>
            <CategoryListLayer />
        </MasterLayout>
    );
};

export default CategoryListPage;
